var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.config
    ? _c(
        "div",
        { key: _setup.elementKey, staticClass: "calendar-section" },
        [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(_setup.CInput, {
                staticClass: "col-6",
                attrs: {
                  value: Number(_setup.config.daysTopMargin),
                  type: "decimal",
                  step: ".1",
                  min: 0,
                  label: "Top Margin",
                  disabled: _setup.disabled,
                },
                on: {
                  input: function ($event) {
                    _setup.update({ daysTopMargin: String($event) })
                  },
                },
              }),
              _vm._v(" "),
              _c(_setup.CInput, {
                staticClass: "col-6",
                attrs: {
                  value: Number(_setup.config.daysBottomMargin),
                  type: "decimal",
                  step: ".1",
                  min: 0,
                  label: "Bottom Margin",
                  disabled: _setup.disabled,
                },
                on: {
                  input: function ($event) {
                    _setup.update({ daysBottomMargin: String($event) })
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-wrap justify-content-between" },
            [
              _c(_setup.CCheckbox, {
                attrs: {
                  value: _setup.config.showHorizontalLine,
                  label: "Show Days Separator Line",
                  disabled: _setup.disabled,
                },
                on: {
                  input: function ($event) {
                    return _setup.update({ showHorizontalLine: $event })
                  },
                },
              }),
              _vm._v(" "),
              _c(_setup.CCheckbox, {
                attrs: {
                  value: _setup.config.sundayFirst,
                  label: "Sunday First",
                  disabled: _setup.disabled,
                },
                on: {
                  input: function ($event) {
                    return _setup.update({ sundayFirst: $event })
                  },
                },
              }),
              _vm._v(" "),
              _c(_setup.CCheckbox, {
                attrs: {
                  value: _setup.config.showDaysTitles,
                  label: "Show Day Titles",
                  disabled: _setup.disabled,
                },
                on: {
                  input: function ($event) {
                    return _setup.update({ showDaysTitles: $event })
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _setup.config.showHorizontalLine
            ? _c(_setup.CalendarColorField, {
                attrs: {
                  title: "Day Separator Line",
                  value: _setup.config.lineColor,
                  disabled: _setup.disabled,
                },
                on: {
                  input: function ($event) {
                    return _setup.update({ lineColor: $event })
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.config.showDaysTitles
            ? [
                _c(_setup.CalendarFieldTitle, [_vm._v("Day Titles")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c(_setup.CInput, {
                      staticClass: "col-6",
                      attrs: {
                        value: _setup.config.dayLetters.split(",").join(", "),
                        type: "text",
                        label: "Day Titles",
                        placeholder: "S, M, T, W, T, F, S",
                        disabled: _setup.disabled,
                      },
                      on: { input: _setup.onDayLettersChange },
                    }),
                    _vm._v(" "),
                    _c(_setup.CInput, {
                      staticClass: "col-6",
                      attrs: {
                        value: Number(_setup.config.daysTitlesFontSize),
                        type: "decimal",
                        step: ".1",
                        min: 0,
                        label: "Font size (pts)",
                        disabled: _setup.disabled,
                      },
                      on: {
                        input: function ($event) {
                          _setup.update({ daysTitlesFontSize: String($event) })
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(_setup.CalendarFontField, {
                  attrs: {
                    value: _setup.config.daysTitlesFontPath,
                    disabled: _setup.disabled,
                  },
                  on: {
                    input: function ($event) {
                      return _setup.update({ daysTitlesFontPath: $event })
                    },
                  },
                }),
                _vm._v(" "),
                _c(_setup.CalendarColorField, {
                  attrs: {
                    value: _setup.config.daysTitlesColor,
                    disabled: _setup.disabled,
                  },
                  on: {
                    input: function ($event) {
                      return _setup.update({ daysTitlesColor: $event })
                    },
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(_setup.CalendarFieldTitle, [_vm._v("Days")]),
          _vm._v(" "),
          _c(_setup.CInput, {
            attrs: {
              "data-testid": "calendar-day-font-size",
              value: Number(_setup.config.dayFontSize),
              type: "decimal",
              step: ".1",
              min: 0,
              label: "Font size (pts)",
              disabled: _setup.disabled,
            },
            on: { input: _setup.onDayFontSizeChange },
          }),
          _vm._v(" "),
          _c(_setup.CalendarFontField, {
            attrs: {
              value: _setup.config.dayFontPath,
              disabled: _setup.disabled,
            },
            on: {
              input: function ($event) {
                return _setup.update({ dayFontPath: $event })
              },
            },
          }),
          _vm._v(" "),
          _c(_setup.CalendarColorField, {
            attrs: { value: _setup.config.dayColor, disabled: _setup.disabled },
            on: {
              input: function ($event) {
                return _setup.update({ dayColor: $event })
              },
            },
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }